import script from "./ActivityWarehousesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityWarehousesList.vue?vue&type=script&setup=true&lang=js"

import "./ActivityWarehousesList.vue?vue&type=style&index=0&id=66af704a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66af704a"]])

export default __exports__